export default "__VITE_ASSET__1b047999__"